import gsap from 'gsap';

gsap.set(".spin-element", { xPercent: -50, yPercent: -50, transformOrigin: "50% 50%" });

gsap.to(".section-features-banner .image-small-circle .spin-element", {
    rotation: 180,
    duration: 10,
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut"
});

let age = 18;

let access = (age >18) ? 'ok' : 'no';
console.log(access);